import React from "react";
//#region types
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
//endregion
//#region components
import { TitledContainerInner, EntityCardContent } from "components/common";
import { TimeLogsFormContainer, TimeLogsTodoFooter } from "components/timeReporting";
import { Grid } from "@mui/material";
import useSalaryDeviationAndTimeReportTodoHelper from "./useSalaryDeviationAndTimeReportTodoHelper";
import useSalaryPermissions from "components/salary/hooks/useSalaryPermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { SalaryDeviationAndTimeReportTopTodoCard } from "components/todos/_partials";

const SalaryDeviationAndTimeLogReportTodo: React.FC<TodoCardProps> = (props) => {
  const {
    salaryDeviationAndTimeLog,
    reportData,
    deviationMonthState,
    noOfReportsToApprove,
    reloadTodo,
    onViewInfoClick,
    onRowsUpdate,
  } = useSalaryDeviationAndTimeReportTodoHelper(props.item.salaryDeviationAndTimeLogReport!, props.onActionSuccess);
  const { isWintSalaryCompany } = useSalaryPermissions();

  const hiddenColumns: (keyof ApiModel.TimeReportingReportColumn)[] = [
    "timeReportInvoiceStatus",
    "invoicedAmount",
    "hoursToInvoice",
    "calculatedAmount",
    "hourlyRate",
    "utilizationRate",
    "commentsCount",
  ];
  if (isWintSalaryCompany) {
    hiddenColumns.push("absence", "allowance");
  }

  return (
    <EntityCardContent
      topTodoCard={
        <SalaryDeviationAndTimeReportTopTodoCard
          item={props.item}
          report={salaryDeviationAndTimeLog}
          noOfReportsToApprove={noOfReportsToApprove}
          onViewInfoClick={onViewInfoClick}
        ></SalaryDeviationAndTimeReportTopTodoCard>
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(
            isWintSalaryCompany
              ? TranslationKeys.TimeReporting.ConfirmTimeReports
              : TranslationKeys.TimeReporting.ConfirmReports
          )}
          subHeader={`${LocalizationHelperInstance.getFormattedMessage(
            isWintSalaryCompany
              ? TranslationKeys.TimeReporting.ConfirmTimeReportsDescription
              : TranslationKeys.TimeReporting.ConfirmReportsDescription
          )} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.ClickToChange)}`}
        />
      }
      infoViewer={
        <Grid container marginTop={-2.5}>
          <TimeLogsFormContainer
            dataRows={reportData}
            onTimeReportRowsChange={onRowsUpdate}
            hiddenColumns={hiddenColumns}
            allowCheckBoxSelection
            allowPagination
            allowGrouping
            compactTable
          ></TimeLogsFormContainer>
        </Grid>
      }
      footer={
        <TimeLogsTodoFooter
          selectedRows={(reportData ?? []).filter((row) => (row as any).selected && !(row as any).disabled)}
          allRows={reportData ?? []}
          reloadHandler={reloadTodo}
          salaryDeviationMonthState={deviationMonthState}
          disableSuccessMessages
        />
      }
    ></EntityCardContent>
  );
};

export default SalaryDeviationAndTimeLogReportTodo;
